import React, { useState } from "react";
import Button from "../../_components/button/Button";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/outline";
import { XCircleIcon } from "@heroicons/react/solid";
import { Dialog, Transition } from "@headlessui/react";

const StreamingOptions = () => {
  const options = [
    {
      name: "Apple AirPlay",
      image:
        "https://cdn.pmlsound.com/anthem/avm90/images/LivingRoom-432X289-AppleAirplay.png",
      description:
        "AVM 90 supports Apple AirPlay and AirPlay 2, letting the user stream audio content, plus songs stored on local networks, to any AirPlay-enabled device. In addition, AirPlay 2 adds support for multi device play so you can hear your music throughout the home.",
    },
    {
      name: "Google Chromecast",
      image:
        "https://cdn.pmlsound.com/anthem/avm90/images/DiningRoom-432X289-GoogleChromecast-2.png",
      description:
        "Google Chromecast, lets the user stream audio content from any Android device like a phone, tablet, or laptop to the AVM 90. If you can listen to it on your phone, it can be Cast to your processor.",
    },
    {
      name: "Spotify Connect",
      image:
        "https://cdn.pmlsound.com/anthem/avm90/images/Office-432X289-White-Spotify.png",
      description:
        "AVM 90 supports Spotify Connect allowing you to turn your smartphone into a remote and allows you to play, pause, and stream content from Spotify.",
    },
    {
      name: "Bluetooth",
      image:
        "https://cdn.pmlsound.com/anthem/avm90/images/Bedroom-432X289-Bluetooth-White.png",
      description:
        "AVM 90 supports Bluetooth to stream songs stored on devices like phones, tablets, and laptops.",
    },
    {
      name: "Roon (Coming Soon!)",
      image:
        "https://cdn.pmlsound.com/anthem/avm90/images/HomeTheatre-432X289-Roon-2.png",
      description:
        "AVM 90 supports Roon allowing you to connect, stream and manage your music collection. Roon tells your music what to do and where to do it.",
    },
  ];

  const [highlighted, setHighlighted] = useState(0);

  return (
    <section className="z-50 relative">
      <div className="bg-black  px-5  bg-no-repeat bg-cover z-50">
        <div
          className="max-w-7xl mx-auto  md:py-20 py-12"
          id="streaming_options"
        >
          <div className="lg:flex ">
            <h4 className="md:w-full lg:w-1/2 text-4xl md:text-5xl lg:text-6xl font-bold text-center lg:text-left  text-white leading-snug">
              Flexible Streaming options to meet your needs
            </h4>

            <p className="md:w-full lg:w-1/2 text-xl  font-light text-center lg:text-left  text-white mt-10 lg:mt-0 ">
              The AVM 90 includes a robust set of streaming options that can
              pull your music in from local storage or from the Internet. Thanks
              to Anthem’s high-speed processing and premium digital-to-analog
              conversion using high-end DACs, sound quality can be every bit as
              good as dropping a CD into a dedicated disc player.
            </p>
          </div>

          <div
            className="grid xl:grid-cols-5 lg:grid-cols-4 md:grid-cols-2 grid-cols-1 gap-3  mt-10   h-0 invisible md:h-full  md:visible"
            style={{ zIndex: 100 }}
          >
            {options.map((option) => (
              <div className="streaming_option rounded-sm bg-gray-200 shadow-md shadow-white/30 ">
                <div className="p-2">
                  <img src={option.image} className="" />
                  <h5 className="text-gray-900  text-xl font-bold py-4">
                    {option.name}
                  </h5>
                  <p class="text-gray-900  text-md font-light">
                    {option.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
          <div className="md:h-0 visible   md:invisible">
            <div className="streaming_option w-3/4  rounded-md bg-gray-100 shadow-md shadow-white/50 m-auto">
              <div className="p-3">
                <img src={options[highlighted].image} className="" />
                <h5 className="text-gray-900  text-xl font-bold py-4">
                  {options[highlighted].name}
                </h5>
                <p class="text-gray-900  text-md font-light">
                  {options[highlighted].description}
                </p>
              </div>
            </div>
            <div className="w-3/4 text-center mt-10 m-auto">
              <div className="grid    grid-cols-2 gap-4 justify-items-stretch">
                <div className="justify-self-end ">
                  <Button
                    name={<ChevronLeftIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={() => {
                      setHighlighted(highlighted - 1);
                    }}
                    disabled={highlighted == 0 ? true : false}
                  />
                </div>

                <div className="justify-self-start">
                  <Button
                    name={<ChevronRightIcon className="h-6 w-6" />}
                    dark={true}
                    centered={true}
                    width={"fit"}
                    handleClick={() => {
                      setHighlighted(highlighted + 1);
                    }}
                    disabled={options.length - 1 == highlighted ? true : false}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default StreamingOptions;
